import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../component/Loader";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";

function CheckOut() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [orderSummary, setOrderSummary] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [orders, setOrders] = useState({
    user_id: JSON.parse(secureLocalStorage.getItem("user"))?.id || null,
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    company: "",
    address1: "",
    address2: "",
    state: "",
    zip: "",
    country: "",
    town: "",
    order_note: "",
    payment_status: "pending",
    stripe_charge_id: "",
    order_summary: {
      subtotal: 0,
      total: 0,
      shipping: 0,
      tax: 0,
    },
    ordered_products: [],
  });

  const fetchCartData = () => {
    let items = [];
    let products = [];
    const keys = Object.keys(localStorage);

    keys.forEach((key) => {
      if (key.startsWith("@secure.") || key === "order" || key === "user") return;
      try {
        const raw = localStorage.getItem(key);
        if (!raw) return;
        if (raw.trim().startsWith("{") || raw.trim().startsWith("[")) {
          const item = JSON.parse(raw);
          if (item && item.id && item.name) {
            items.push(item);
            products.push({
              cart: {
                id: item.id,
                price: item.price,
                quantity: item.quantity,
                volume: item.volume,
              },
            });
          }
        }
      } catch (err) {
        console.error("Invalid JSON in localStorage key:", key, err);
      }
    });

    setCartItems(items);

    let subtotal = items.reduce((acc, item) => acc + item.price * item.quantity, 0);
    let shipping = items.length > 0 ? 0 : 0;
    let total = subtotal + shipping;

    setOrders((prev) => ({
      ...prev,
      order_summary: {
        subtotal,
        total,
        shipping,
        tax: 0,
      },
      ordered_products: products,
    }));

    setOrderSummary({ subtotal, total, shipping, tax: 0 });
  };

  useEffect(() => {
    fetchCartData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOrders((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!orders.first_name?.trim()) return "First Name is required";
    if (!orders.last_name?.trim()) return "Last Name is required";
    if (!orders.email?.trim()) return "Email is required";
    if (!/\S+@\S+\.\S+/.test(orders.email)) return "Enter a valid Email address";
    if (!orders.phone?.trim()) return "Phone Number is required";
    if (!orders.address1?.trim()) return "Shipping Address is required";
    if (!orders.country?.trim()) return "Country is required";
    if (!orders.town?.trim()) return "City is required";
    if (!orders.zip?.trim()) return "Postal Code is required";
    return null;
  };

  const saveOrder = async (e) => {
    e.preventDefault();
    const errorMsg = validateForm();
    if (errorMsg) {
      toast.error(errorMsg);
      return;
    }

    setIsSubmitting(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}api/save-order`, orders);

      if (res.data.code === 200 && res.data.status === true) {
        const orderNumber = res.data?.data?.order_number;
        toast.success("Order saved. Redirecting to payment...");

        const stripeRes = await axios.post(`${process.env.REACT_APP_API_URL}api/payments/create-intent`, {
          order_number: orderNumber,
        });
        if (!stripeRes.data?.clientSecret) {
          toast.error("Failed to initialize payment.");
          return;
        }
        setOrders({});
        navigate("/payment", {
          state: {
            clientSecret: stripeRes.data.clientSecret,
            orderNumber,
            totalAmount: res.data?.data?.total_amount || orders.order_summary.total,
            productNames: cartItems.map((i) => i.name),
          },
        });
      }
    } catch (error) {
      toast.error("Failed to place order.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!orderSummary) return <Loader />;

  console.log(cartItems)

  return (
    <section className="bg-black text-white font-outfit pt-20 pb-20 mt-40">
      <div className="container mx-auto max-w-6xl grid lg:grid-cols-3 gap-10">
        <div className="border border-gray-700 rounded-2xl p-6 lg:col-span-2 space-y-8">
          <h2 className="text-2xl font-bold text-cyan-400 mb-6 font-syne">Fill Out The Details</h2>
          <form className="grid grid-cols-1 md:grid-cols-2 gap-6" onSubmit={saveOrder}>
            <input name="first_name" value={orders.first_name} onChange={handleChange} placeholder="Enter Your First Name *" className="p-3 rounded-full bg-black border border-gray-600" />
            <input name="last_name" value={orders.last_name} onChange={handleChange} placeholder="Enter Your Last Name *" className="p-3 rounded-full bg-black border border-gray-600" />
            <input name="email" value={orders.email} onChange={handleChange} placeholder="Enter Your Email Address *" className="p-3 rounded-full bg-black border border-gray-600" />
            <input name="phone" value={orders.phone} onChange={handleChange} placeholder="Enter Your Phone Number *" className="p-3 rounded-full bg-black border border-gray-600" />
            <input name="address1" value={orders.address1} onChange={handleChange} placeholder="Enter Your Shipping Address *" className="col-span-2 p-3 rounded-full bg-black border border-gray-600" />
            <input name="address2" value={orders.address2} onChange={handleChange} placeholder="Enter Your Address Line 2 (Optional)" className="col-span-2 p-3 rounded-full bg-black border border-gray-600" />
            <input name="country" value={orders.country} onChange={handleChange} placeholder="Enter Your Country *" className="p-3 rounded-full bg-black border border-gray-600" />
            <input name="town" value={orders.town} onChange={handleChange} placeholder="Enter Your City *" className="p-3 rounded-full bg-black border border-gray-600" />
            <input name="state" value={orders.state} onChange={handleChange} placeholder="Enter Your State" className="p-3 rounded-full bg-black border border-gray-600" />
            <input name="zip" value={orders.zip} onChange={handleChange} placeholder="Enter Your Postal Code *" className="p-3 rounded-full bg-black border border-gray-600" />
            <textarea name="order_note" value={orders.order_note} onChange={handleChange} placeholder="Order Notes (Optional)" className="col-span-2 p-3 rounded-xl bg-black border border-gray-600" />
            <div className="col-span-2">
              <button type="submit" className="px-8 py-3 bg-cyan-400 text-black rounded-full font-bold font-syne w-fit">
                {isSubmitting ? "Confirming..." : "Confirm Order"}
              </button>
            </div>
          </form>
        </div>
        <div className="bg-black border border-gray-700 rounded-2xl p-6 space-y-6 h-fit">
          <h2 className="text-2xl font-bold text-cyan-400 font-syne">Order Summary</h2>
          <div className="space-y-4 max-h-[250px] overflow-y-auto">
            {cartItems.map((item) => (
              <div className="flex items-center gap-4 p-2 border border-brandBlue rounded-2xl" key={item.id}>
                <img
                  src={`${process.env.REACT_APP_SITE_IMAGES}${item.photo}`}
                  alt={item.name}
                  className="w-16 h-16 rounded-lg object-contain bg-brandBlue p-2"
                />
                <div>
                  <p className="font-semibold font-outfit">{item.name}</p>
                  <span className="text-sm text-gray-400">${item.price} x {item.quantity}</span>
                </div>
                <div>
                  <p className="font-semibold font-outfit">Volume Range</p>
                  <span className="text-sm text-gray-400">${item.volume}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="text-gray-300 space-y-2 text-sm font-outfit">
            <div className="flex justify-between"><span>Subtotal:</span><span>${orderSummary.subtotal}</span></div>
            <div className="flex justify-between"><span>Shipping:</span><span>${orderSummary.shipping}</span></div>
            <div className="flex justify-between font-bold text-white text-lg pt-2 border-t border-white">
              <span>Total:</span><span>${orderSummary.total}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CheckOut;
